import styled, { css } from 'styled-components/macro';
import { Text } from '../Typography';
import { themeGetAsRem } from '@blueprint/ui';

const SpinnerLabel = styled(Text)`
  ${({ hMedia, variant, labelPosition }) => css`
    ${themeGetAsRem(
      `spinner.${
        hMedia ? 'hBreakpoints' : 'compact'
      }.label.sizeMapping.${variant}`,
    )};
    ${themeGetAsRem(
      `spinner.${
        hMedia ? 'hBreakpoints' : 'compact'
      }.label.positionMap.${labelPosition}`,
    )};
  `};
`;

SpinnerLabel.displayName = 'SpinnerLabel';

export default SpinnerLabel;
